import React from 'react';
import { useTranslation } from 'react-i18next';
import urljoin from 'url-join';
import { useHistory, useLocation } from 'react-router';
import queryString from 'query-string';

import { useConfig } from 'Context/ConfigContext';
import { Flex, Text } from 'Components/Base';
import Loading from 'Components/Loading';
import { useCapacitor } from 'Util/Capacitors';
import fetch2, { METHOD } from 'Util/fetch';

const RedirectMyPath = () => {
  const { t } = useTranslation('classroom');
  const { userApi, myPath: myPathConfig } = useConfig();
  const { openUrl } = useCapacitor();
  const location = useLocation();
  const history = useHistory();

  const querySearchParam = queryString.parse(location.search);
  const queryHashParam = queryString.parse(location.hash);
  const redirectUrlParam = querySearchParam?.redirectUrl || null;
  const continueParam = queryHashParam?.continue || null;
  const continueHas = continueParam ? `#${continueParam}` : '';
  const redirectUrl = redirectUrlParam ? urljoin(redirectUrlParam, continueHas) : null;

  const openMyPath = async (redirectPath) => {
    const myPathLoginUrl = myPathConfig?.loginUrl;
    if (myPathLoginUrl) {
      const token = await fetch2(urljoin(userApi, '/me/session'), {}, METHOD.POST, null, {
        isRedirect: false,
        includeCredentials: true,
      });
      const fullURL = token ? myPathLoginUrl.replace('{token}', token) : myPathLoginUrl;
      const fullURLWithPath = urljoin(fullURL, redirectPath);
      openUrl(fullURLWithPath, () => {
        window.open(fullURLWithPath, '_blank');
      });
    }
    history.push('/');
  };

  const encodeUrl = redirectUrl ? encodeURIComponent(redirectUrl) : null;
  const redirectPath = encodeUrl ? `?redirect=${encodeUrl}` : '';
  openMyPath(redirectPath);

  return (
    <Flex width={1} flexDirection={'column'} justifyContent={'center'} alignItems={'center'} mt={8}>
      <Loading />
      <Text mt={3}>{t('LOADING')}</Text>
    </Flex>
  );
};

export default RedirectMyPath;
